export default "__VITE_ASSET__7c60234b__"